// Codici sollevati dalle RPC/vincoli Supabase e messaggi di rete tradotti per l'utente.
const KNOWN_ERROR_MESSAGES: Array<[code: string, message: string]> = [
  [
    "open_visit_already_exists",
    "Risulta già un ingresso aperto con questi dati. Registra prima l'uscita oppure rivolgiti alla reception.",
  ],
  [
    "open_visit_not_found",
    "La visita selezionata risulta già chiusa. Aggiorna l'elenco e riprova.",
  ],
  ["checkin_signature_required", "La firma è obbligatoria."],
  ["checkout_signature_required", "La firma di uscita è obbligatoria."],
  ["first_name_required", "Il nome è obbligatorio."],
  ["last_name_required", "Il cognome è obbligatorio."],
  ["company_required", "L'azienda è obbligatoria."],
  ["visit_ids_required", "Seleziona almeno una visita."],
  ["visit_id_required", "Seleziona il visitatore da registrare in uscita."],
  ["admin_required", "Operazione riservata agli amministratori."],
  ["checkout_in_future", "L'orario di uscita non può essere nel futuro."],
  [
    "checkout_before_checkin",
    "L'orario di uscita non può precedere l'orario di arrivo.",
  ],
  [
    "visits_checkout_consistency",
    "Non è possibile riaprire una visita chiusa con la firma del visitatore.",
  ],
  [
    "Failed to fetch",
    "Connessione assente o instabile. Verifica la rete e riprova.",
  ],
];

function translateKnownError(message: string) {
  const match = KNOWN_ERROR_MESSAGES.find(([code]) => message.includes(code));
  return match ? match[1] : message;
}

export function toErrorMessage(
  error: unknown,
  fallback = "Si è verificato un errore imprevisto.",
): string {
  if (error instanceof Error && error.message.trim()) {
    return translateKnownError(error.message);
  }

  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string" &&
    error.message.trim()
  ) {
    return translateKnownError(error.message);
  }

  return fallback;
}

export function isAbortError(error: unknown) {
  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    error.name === "AbortError"
  );
}

export function assertCondition(
  condition: unknown,
  message: string,
): asserts condition {
  if (!condition) {
    throw new Error(message);
  }
}
